import { Injectable, NgZone, inject, isDevMode } from "@angular/core";
import type API from "@openreplay/tracker";
import type { User } from "src/app/schema";
import { environment } from "src/environments/environment";

const ENABLE_IN_DEV_MODE = false;

@Injectable({
	providedIn: "root",
})
export class OpenReplayService {
	private readonly _ngZone = inject(NgZone);

	private _tracker: API | undefined;

	public async start(): Promise<void> {
		if (this._tracker) return;
		if (isDevMode() && !ENABLE_IN_DEV_MODE) return;
		await this._start();
	}

	public identifyUser(user: User): void {
		this._ngZone.runOutsideAngular(() => {
			if (this._tracker) {
				this._tracker.setUserID(user.id);
				this._tracker.setMetadata("firstName", user.firstName);
				this._tracker.setMetadata("lastName", user.lastName);
			}
		});
	}

	private async _start(): Promise<void> {
		const Tracker = (await import("@openreplay/tracker")).default;
		const TrackerAssist = (await import("@openreplay/tracker-assist")).default;
		const { projectKey } = environment.openReplay;
		// Use runOutsideAngular to avoid zone polution.
		// https://docs.openreplay.com/en/using-or/angular
		this._ngZone.runOutsideAngular(() => {
			this._tracker = new Tracker({
				projectKey,
				obscureInputDates: false,
				obscureInputEmails: false,
				obscureInputNumbers: false,
				obscureTextEmails: false,
				obscureTextNumbers: false,
				defaultInputMode: 0,
				__DISABLE_SECURE_MODE: isDevMode(),
			});
			this._tracker.use(TrackerAssist());
			this._tracker.start();
		});
	}
}
